<template>
  <div>
    <h4 class="mb-4">Similar RTPs</h4>
    <div v-if="amReady">

      <div class="row pl-0 pr-3">
        <div class="col-12 col-md-4">
          <dg-text-field
              :field_span="22"
            :label_span="22"
              :liveUpdate="true"
              @amUpdated="userSearchUpdated"
              field_mark=""
              placeholder="search destination"></dg-text-field>
        </div>
      </div>

      <el-collapse :key="key" @change="handleChange"
                   class="mb-2" v-for="(destinations, key) in similarDestinations" v-model="activeDestinations">
        <el-collapse-item :name="key">
          <template slot="title">
            <div class="ml-2">
              <!--<i class="header-icon el-icon-info"></i>-->
              <h6 class="text-uppercase mb-0">{{ key }}</h6>
            </div>
          </template>
          <div :key="desIndex" class="ml-4" v-for="(destination, desIndex) in destinations">
            <el-tag style="font-size: 16px">RTP Segment: {{ desIndex }}</el-tag>
            <div :key="rtpIndex" class="ml-4" v-for="(rtp, rtpIndex) in destination">
              <div>
                {{ rtp.rtp_1 + ' - ' + rtp.vendor_1 }}
              </div>
              <div>
                {{ rtp.rtp_2 + ' - ' + rtp.vendor_2 }}
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import module from './../index.js'


export default {
  components: {
    // pagination: () => import('@/components/pagination/View.vue'),
  },
  data() {
    return {
      currentPage: 1,
      userSearch: '',
      userSearchTimeOut: null,
      activeDestinations: [],
      searchMe: null,
      module: {
        ...module
      },
      amReady: false,
      editMode: false,
      dialogVisible: false,
      rowsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      similarDestinations: {}
    };
  },
  beforeMount() {
    this.reloadList()
  },
  methods: {
    ...$mapActions('voip-rtp-finder-api', {
      getEntityList: 'list'
    }),
    reloadList() {
      this.getEntityListData("0000")
    },
    setIsRateActive(params) {
      let data = {
        is_active: (params.value == true) ? 1 : 0,
      }
      this.updateCustomerRate({data, id: params.id})
    },
    getEntityListData(page) {
      let data = {
        page: page,
        destination: this.userSearch
        //search: this.userSearch,
      }

      this.currentPage = page
      this.getEntityList(data).then(response => {
        this.buildAgGridData(response)
      })
    },
    buildAgGridData(response) {
      this.similarDestinations = null
      this.similarDestinations = {}
      let records = response.rows

      let userSearch = this.userSearch.toLocaleLowerCase()
      for (let x in records) {
        let mainSegment = records[x].rtp.split('.')
        mainSegment.pop()
        mainSegment = mainSegment.join('.')

        if (mainSegment == '' || mainSegment == '-') continue

        for (let y in records) {
          let similarSegment = records[y].rtp.split('.')
          similarSegment.pop()
          similarSegment = similarSegment.join('.')

          if (records[y].id == records[x].id) continue

            let mainDestination = records[x].destination
            let similarDestination = records[y].destination

            if (similarSegment == mainSegment && mainDestination == similarDestination) {
              if (!this.similarDestinations.hasOwnProperty(mainDestination)) {
                this.similarDestinations[mainDestination] = {}
              }

              if (!this.similarDestinations[mainDestination].hasOwnProperty(mainSegment)) {
                this.similarDestinations[mainDestination][mainSegment] = []
              }

              if (records[x].vendor != records[y].vendor) {
                this.similarDestinations[mainDestination][mainSegment].push({
                  vendor_1: records[x].vendor,
                  vendor_2: records[y].vendor,
                  rtp_1: records[x].rtp,
                  rtp_2: records[y].rtp
                })
              }
            }
        }
      }

      for(let dest in this.similarDestinations) {
        if(Object.keys(this.similarDestinations[dest]).length == 1) {
          for (let segment in this.similarDestinations[dest]) {
            if(Object.keys(this.similarDestinations[dest][segment]).length == 0) {
              delete this.similarDestinations[dest]
            }
          }
        }
      }
      this.amReady = true
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData('0000') //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    handleChange(val) {
    }
  }
}
</script>
